import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import {
  Company,
  Deal,
  EntityTypeSupportingPostCreationModal,
  Person,
} from "@mapmycustomers/shared/types/entity";

export const showGlobalPostCreationModal = createAction("@component/globalPostCreationModal/show")<{
  entity: Company | Deal | Person;
  entityType: EntityTypeSupportingPostCreationModal;
}>();

export const hideGlobalPostCreationModal = createAction(
  "@component/globalPostCreateCompanyModal/hide"
)<void>();

export const addCompanyChildCompanies = createAsyncAction(
  "postCreationModal/addCompanyChildCompanies/request",
  "postCreationModal/addCompanyChildCompanies/success",
  "postCreationModal/addCompanyChildCompanies/failure"
)<{ companiesIds: Array<Company["id"]>; id: Company["id"] }, Company[], void>();

export const addCompanyDeals = createAsyncAction(
  "postCreationModal/addCompanyDeals/request",
  "postCreationModal/addCompanyDeals/success",
  "postCreationModal/addCompanyDeals/failure"
)<{ dealIds: Array<Deal["id"]>; id: Company["id"] }, Deal[], void>();

export const addPersonDeals = createAsyncAction(
  "postCreationModal/addPersonDeals/request",
  "postCreationModal/addPersonDeals/success",
  "postCreationModal/addPersonDeals/failure"
)<{ dealIds: Array<Deal["id"]>; id: Person["id"] }, Deal[], void>();

export const addCompanyParentCompany = createAsyncAction(
  "postCreationModal/addCompanyParentCompany/request",
  "postCreationModal/addCompanyParentCompany/success",
  "postCreationModal/addCompanyParentCompany/failure"
)<{ id: Company["id"]; parentCompanyId: Company["id"] }, Company, void>();

export const addPersonCompanies = createAsyncAction(
  "postCreationModal/addPersonCompanies/request",
  "postCreationModal/addPersonCompanies/success",
  "postCreationModal/addPersonCompanies/failure"
)<{ companyIds: Company["id"][]; id: Person["id"] }, Company[], void>();

export const addDealParentCompany = createAsyncAction(
  "postCreationModal/addDealParentCompany/request",
  "postCreationModal/addDealParentCompany/success",
  "postCreationModal/addDealParentDeal/failure"
)<{ id: Deal["id"]; parentCompanyId: Company["id"] }, Company, void>();

export const addCompanyPeople = createAsyncAction(
  "postCreationModal/addCompanyPeople/request",
  "postCreationModal/addCompanyPeople/success",
  "postCreationModal/addCompanyPeople/failure"
)<{ id: Company["id"]; peopleIds: Array<Person["id"]> }, Person[], void>();

export const addDealParentPerson = createAsyncAction(
  "postCreationModal/addDealParentPerson/request",
  "postCreationModal/addDealParentPerson/success",
  "postCreationModal/addDealParentPerson/failure"
)<{ id: Deal["id"]; parentPersonId: Person["id"] }, Person, void>();

export type Actions = ActionType<
  | typeof addCompanyChildCompanies
  | typeof addCompanyDeals
  | typeof addCompanyParentCompany
  | typeof addCompanyPeople
  | typeof addDealParentCompany
  | typeof addDealParentPerson
  | typeof addPersonCompanies
  | typeof addPersonDeals
  | typeof hideGlobalPostCreationModal
  | typeof showGlobalPostCreationModal
>;
